<app-filter-panel [fields]="fieldsConfig" (search)="loadWorkerBillableItemLines(null)"></app-filter-panel>

<!--
<div class="grid mb-4" *ngIf="type != 'worker_invoice_request'">
    <div class="col-3 input-field">
        <label for="workerId">Operario</label>
        <p-dropdown [options]="workers" [(ngModel)]="filters.workerId.value" optionLabel="name" optionValue="id"
            [filter]="true" filterBy="name" appendTo="body" placeholder="Selecciona un operador" showClear
            (onChange)="loadWorkerBillableItemLines(null)"
            (onFilter)="loadWorkers($event)"
            (onClear)="loadWorkers(null);"></p-dropdown>
    </div>
    <div class="col-2 input-field">
        <label for="dateStart">Desde</label>
        <p-calendar [firstDayOfWeek]="1" [(ngModel)]="filters.dateFrom.value" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
            [yearNavigator]="true" dateFormat="dd/mm/yy" d-form-field-error appendTo="body"
             (onSelect)="loadWorkerBillableItemLines(null)"
            (onClear)="loadWorkerBillableItemLines(null)"
            ></p-calendar>
    </div>
    <div class="col input-field">
        <label>&nbsp;</label>
        <div class="flex gap-2">
            <p-button label="Limpiar filtros" (click)="clearFilters()" />
        </div>
    </div>
</div>
-->

<p-table #grid [value]="workerBillableItemLines"
    [lazy]="true" (onLazyLoad)="loadWorkerBillableItemLines($event)"
    [paginator]="true" [rows]="25" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
    [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
    <ng-template pTemplate="header">
        <tr>
            <th pSortableColumn="worker.name">Operario <p-sortIcon field="worker.name"></p-sortIcon></th>
            <th pSortableColumn="date">Fecha <p-sortIcon field="date"></p-sortIcon></th>
            <th pSortableColumn="description">Descripción <p-sortIcon field="description"></p-sortIcon></th>
            <th pSortableColumn="quantity">Cantidad <p-sortIcon field="quantity"></p-sortIcon></th>
            <th pSortableColumn="price">Precio <p-sortIcon field="price"></p-sortIcon></th>
            <th pSortableColumn="taxPercent">Impuestos(%) <p-sortIcon field="taxPercent"></p-sortIcon></th>
            <th pSortableColumn="subtotal">Neto <p-sortIcon field="subtotal"></p-sortIcon></th>
            <th pSortableColumn="total">Total <p-sortIcon field="total"></p-sortIcon></th>
            <th pSortableColumn="transaction.code">Factura <p-sortIcon field="transaction.code"></p-sortIcon></th>
            <th></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-line>
        <tr>
            <td>{{ line.worker?.name }}</td>
            <td>{{ line.date | date:'dd/MM/yyyy' }}</td>
            <td>{{ line.description }}</td>
            <td>{{ line.quantity }}</td>
            <td>{{ line.price | currency:'EUR':'symbol':'1.2-2' }}</td>
            <td>{{ line.taxPercent | currency:'EUR':'symbol':'1.2-2' }}</td>
            <td>{{ line.subtotal | currency:'EUR':'symbol':'1.2-2' }}</td>
            <td>{{ line.total | currency:'EUR':'symbol':'1.2-2' }}</td>
            <td>
                <a *ngIf="line.transactionId" pTooltipPosition="top" [pTooltip]="'Fecha: ' + line.transaction?.date.toLocaleDateString()" href="/transactions/{{ line.transaction?.transactionType?.code }}/{{ line.transactionId }}">{{ line.transaction?.code }}</a>
            </td>
            <td>
                <div class="flex gap-2">
                    <p-button (click)="info(line)" [rounded]="true" [text]="false" severity="info"><i class="pi pi-info-circle"></i></p-button>
                    <p-button *ngIf="allowDelete && line.transaction?.netSuiteId == null" (click)="delete(line)" [rounded]="true" [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>

<!-- dialogo con la información del concepto facturable -->
<p-dialog header="Información del concepto facturable" [(visible)]="displayInfoDialog" [modal]="true" [style]="{width: '800px'}" appendTo="body">
    <div *ngIf="selectedLine" [innerHTML]="selectedLine.info" style="white-space: pre-wrap;">
        
    </div>
</p-dialog>

<p-confirmDialog appendTo="body"></p-confirmDialog>